import { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router";
import useAppStore from "../store/AppStore";
import { Assets } from "../assets";
import { BsArrowBarLeft, BsArrowBarRight } from "react-icons/bs";
import { Colors } from "../utilities/colors";
import "../common/components/Menu/style.scss";
import Header from "../common/components/Header/Header";
import AppMenu from "../common/components/Menu/AppMenu";
import { MenuItemData } from "../utilities/menus/MenuStruct";
import { MenuKeys } from "../utilities/menus/MenuKeys";

const MenuContainer = () => {
  const {
    menus,
    openMenu,
    setOpenMenu,
    setShowMenuChild,
    showMenuChild,
    activeMenu,
    setActiveMenu,
    authorizationData,
  } = useAppStore();
  const navigate = useNavigate();
  const location = useLocation();

  const onMenuClick = (menu: MenuItemData) => {
    if (menu.childrenToShow?.length > 0) {
      if (showMenuChild?.title === menu?.title) {
        setShowMenuChild(null);
      } else {
        setShowMenuChild(menu);
      }
    } else {
      navigate(MenuKeys[menu?.routeName ?? ""]?.routeName);
    }
  };

  const menuOpenClose = () => {
    setOpenMenu(!openMenu);
  };

  useEffect(() => {
    let active: MenuItemData | null = null;
    menus?.member?.forEach((menu) => {
      if (
        menu.childrenToShow?.length <= 0 &&
        MenuKeys[menu.routeName] !== undefined &&
        (MenuKeys[menu.routeName].routeName === location.pathname ||
          location.pathname.includes(MenuKeys[menu.routeName].routeName))
      ) {
        active = menu;
      } else if (menu?.childrenToShow?.length > 0) {
        menu?.childrenToShow?.forEach((menuChild) => {
          if (
            MenuKeys[menuChild?.routeName]?.routeName === location.pathname ||
            location.pathname.includes(
              MenuKeys[menuChild?.routeName]?.routeName
            )
          ) {
            active = menuChild;
          }
        });
      }
    });

    setActiveMenu(active);
  }, [location]);

  return (
    <div className="d-flex">
      <div className="menu-ctn">
        <img src={Assets.imagesSvg.logo} width={"150px"} alt="Logo" />
        <div style={{ position: "relative" }}>
          <div
            className={
              "pt-4 custom-menu-left " +
              (!openMenu ? "menu-close " : "menu-open ")
            }
          >
            <div
              className=""
              style={{
                ...(!openMenu
                  ? {}
                  : {
                      padding: "0px 30px",
                    }),
              }}
            >
              {menus && (
                <AppMenu
                  menus={menus}
                  onMenuClick={onMenuClick}
                  openMenu={openMenu}
                  showMenuChild={showMenuChild}
                  activeMenu={activeMenu}
                  userAuthorizedMenus={authorizationData?.menuRouteNames}
                />
              )}
            </div>
          </div>
          <div
            className={
              "menu-open-close " + (openMenu ? " open-menu" : "close-menu")
            }
            onClick={menuOpenClose}
          >
            {openMenu && <BsArrowBarLeft size={24} color={Colors.black} />}
            {!openMenu && <BsArrowBarRight size={24} color={Colors.black} />}
          </div>
        </div>
      </div>
      <div
        className={
          "custom-container " + (openMenu ? "menu-open " : "menu-close ")
        }
      >
        <div className="custom-header">
          <Header />
        </div>
        <div className="">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default MenuContainer;
